import { COLORS } from '@btime/constants'
import React from 'react'

import { Title } from '../../../../packages/kiti/components/presentation/Text'
import PdfBasicOptionsForm from '../../../../components/pdf/options/PdfBasicOptionsForm'
import Separator from '../../../../packages/kiti/components/helpers/Separator'
import Sticky from '../../../../components/helpers/Sticky'

const OptionsForm = () => {
  return (
    <Sticky>
      <Separator weight={4} usePadding>
        <Title size="h5" color={COLORS.dark3}>
          Configurações da impressão
        </Title>
      </Separator>

      <PdfBasicOptionsForm />
      <Separator weight={4} />
    </Sticky>
  )
}

export default OptionsForm
